import { render, staticRenderFns } from "./goldRecord.vue?vue&type=template&id=61cf427c&scoped=true&"
import script from "./goldRecord.vue?vue&type=script&lang=js&"
export * from "./goldRecord.vue?vue&type=script&lang=js&"
import style0 from "./goldRecord.vue?vue&type=style&index=0&id=61cf427c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf427c",
  null
  
)

export default component.exports